/**************************************************
 * Nombre:       Formulario_Curso_Profesores
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import IngresoTexto from "../../../Modulo_formularios/Componentes/IngresoTexto";
import {useIngresarObjeto} from "../../../Modulo_formularios/Hooks/useIngresarObjeto";
import Tarjetas_Valores from "../../Tarjeta/Tarjetas_Valores";
import Formulario_Modulo from "./Formulario_Modulo";
import IngresoPdf from "../../../Modulo_formularios/Componentes/IngresoPdf";
import Tarjetas_Modulo from "../../Tarjeta/Tarjetas_Modulo";
import Formulario_Profesor from "./Formulario_Profesor";

const Formulario_Curso_Profesores = ({...props}) => {
    const {IngresarObjeto} = useIngresarObjeto({
        props: props,
        nombre: 'Agregar Profesor',
        Formulario: Formulario_Profesor,
        dato: 'profesores',
        Tarjeta: Tarjetas_Modulo,
    });

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography>Ingresar Profesores</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <IngresarObjeto/>
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Curso_Profesores